import { z } from 'zod';
import {
    CompanyInformationModelSchema,
} from 'entities/company-information';
import { GetCompanyInformationApiResponseSchema } from '../store';

export const createCompanyInformationFromGetCompanyInformationApiResponse = (
    (response: z.infer< typeof GetCompanyInformationApiResponseSchema>) => (
        CompanyInformationModelSchema.parse({
            name: response.data.name,
            title: response.data.title,
            description: response.data.description,
            phone: response.data.phone,
            address: response.data.address?.name,
            email: response.data.email,
            logoImage: response.data.logoImage && {
                url: response.data.logoImage.url,
            },
            mainImage: response.data.mainImage && {
                url: response.data.mainImage.url,
            },
        })
    )
);
